import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import TlbsMap from 'tlbs-map-vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { createHead } from '@vueuse/head'
import moment from 'moment'

// 确保DOM加载完成
document.addEventListener('DOMContentLoaded', () => {
  const app = createApp(App) 
  app.config.globalProperties.$moment = moment; // 将moment添加到全局属性中 
  const head = createHead()
  app.use(ElementPlus, {
    locale: zhCn,
  })
  app.use(router)
  app.use(TlbsMap)
  app.use(head)
  app.mount('#app')
})
